
import { MapTo } from '@adobe/aem-react-editable-components';
import MitekConfiguration, { MitekConfigurationEditConfig } from './MitekConfiguration';

export default MapTo('cob-corp-acquisition/components/creditonebank/mitek-configuration')(MitekConfiguration, MitekConfigurationEditConfig);
        